export class DismantledSeriesSerialPartNumbersData {

    serialNumber: string;
    partNumber: string;
    nomenclature: string;
}